import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconJavascript = ({
  title = "Javascript",
  viewBoxWidth = 56,
  viewBoxHeight = 56,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g
      id="1440-JS"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="New-Homepage"
        transform="translate(-352.000000, -1064.000000)"
        fillRule="nonzero"
      >
        <g id="Group-2" transform="translate(336.000000, 1048.000000)">
          <g id="JS" transform="translate(16.000000, 16.000000)">
            <rect
              id="Rectangle"
              fill="#F0DB4F"
              x="0.000243478261"
              y="0.00012173913"
              width="55.999513"
              height="55.9997565"
            />
            <path
              d="M30.4750783,43.6750087 C30.4750783,49.1249043 27.2750435,51.6124 22.6124348,51.6124 C18.4001391,51.6124 15.9626783,49.4375304 14.7125391,46.8001739 L18.9999478,44.2126087 C19.8249739,45.6750609 20.5750087,46.9124174 22.3874609,46.9124174 C24.1123826,46.9124174 25.2126609,46.2374957 25.2126609,43.6001391 L25.2126609,25.7125217 L30.4750783,25.7125217 L30.4750783,43.6750087 L30.4750783,43.6750087 Z"
              id="Path-1"
              fill="#323330"
            />
            <path
              d="M42.9249739,51.6124 C38.037513,51.6124 34.8750957,49.2873043 33.3375304,46.2374957 L37.6250609,43.7622957 C38.7500522,45.5999478 40.2249217,46.9623304 42.812487,46.9623304 C44.9874783,46.9623304 46.3872348,45.8749565 46.3872348,44.3625913 C46.3872348,42.5624348 44.9624,41.9252522 42.5500174,40.8625913 L41.2375478,40.3001565 C37.4375826,38.6876 34.9250087,36.6500522 34.9250087,32.3627652 C34.9250087,28.4126957 37.9374435,25.4126783 42.6247652,25.4126783 C45.9747826,25.4126783 48.3747478,26.5751652 50.0997913,29.6252174 L45.9997391,32.2501565 C45.0998435,30.6376 44.1248348,30.0002957 42.6123478,30.0002957 C41.0747826,30.0002957 40.0997739,30.9754261 40.0997739,32.2501565 C40.0997739,33.8252174 41.0747826,34.462887 43.3373043,35.4500696 L44.6496522,36.0126261 C49.1246609,37.9251478 51.637113,39.8878261 51.637113,44.2877217 C51.6373565,49.0124174 47.9122609,51.6124 42.9249739,51.6124 L42.9249739,51.6124 Z"
              id="Path-2"
              fill="#323330"
            />
          </g>
        </g>
      </g>
    </g>
  </Svg.Icon>
)

export default IconJavascript
